/* global Routes */
import React, { useRef, useState, useLayoutEffect, useEffect } from 'react'
import styles from './ContextMenu.scss'
import { defineMessages } from 'react-intl'
import { useFormatMessage } from 'lib/localization'
import { copyToClipboard } from 'lib/copyToClipboard'
import { latLngToPixelCoordinate } from 'common/MapV2/engines/GoogleMapEngine'
import { messages as sidebarMessages } from '../LegacySidebar/Sidebar'
import { messages as leftSidebarMessages } from '../LeftSidebar'
import { messages as rightSidebarMessages } from '../RightSidebar'
import { messages as routeToolsMessages } from '../RouteTools'

const messages = defineMessages({
  addRoute: {
    id: 'ContextMenu.addRoute',
    defaultMessage: 'Start New Route'
  },
  showPosition: {
    id: 'ContextMenu.showPosition',
    defaultMessage: 'Show Lat/Lng'
  },
  removeCue: {
    id: 'ContextMenu.removeCue',
    defaultMessage: 'Remove Cue'
  },
  removePoi: {
    id: 'ContextMenu.removePoi',
    defaultMessage: 'Remove POI'
  },
  removeControlPoint: {
    id: 'ContextMenu.removeControlPoint',
    defaultMessage: 'Remove Control Point'
  },
  addControlPoint: {
    id: 'ContextMenu.addControlPoint',
    defaultMessage: 'Add Control Point'
  },
  addCue: {
    id: 'ContextMenu.addCue',
    defaultMessage: 'Add Custom Cue'
  },
  selectRoute: {
    id: 'ContextMenu.selectRoute',
    defaultMessage: 'Select Route'
  },
  showStreetView: {
    id: 'ContextMenu.showStreetView',
    defaultMessage: 'Show Street View'
  }
})
messages.addPoi = sidebarMessages.createPoi
messages.removeRoute = leftSidebarMessages.removeRoute
messages.splitRoute = routeToolsMessages.splitRoute
messages.undo = rightSidebarMessages.undo
messages.redo = rightSidebarMessages.redo

const modifier = window.navigator.platform.match(/Mac/) ? 'Cmd' : 'Ctrl'

const hotkeyHints = {
  addRoute: 'n',
  undo: `${modifier}-z`,
  redo: `${modifier}-y`
}

const targetItems = {
  map: ['undo', 'redo', 'addPoi', 'addRoute', 'showStreetView', 'showPosition'],
  coursePoint: ['undo', 'redo', 'removeCue', 'showStreetView', 'showPosition'],
  pointOfInterest: ['undo', 'redo', 'removePoi', 'showStreetView', 'showPosition'],
  controlPoint: ['undo', 'redo', 'removeControlPoint', 'addCue', 'addPoi', 'splitRoute', 'showStreetView', 'showPosition'],
  nearestPoint: ['undo', 'redo', 'addControlPoint', 'addCue', 'addPoi', 'splitRoute', 'showStreetView', 'showPosition'],
  startIcon: ['undo', 'redo', 'removeRoute', 'showStreetView', 'showPosition'],
  connectionPoint: ['undo', 'redo', 'selectRoute', 'removeRoute', 'addPoi', 'showStreetView', 'showPosition']
}

export const ContextMenu = ({ event, targetType, targetRef, actions, onRequestClose, ...props }) => {
  const fm = useFormatMessage()
  const ref = useRef()
  const pxCoords = latLngToPixelCoordinate(event.latLng, Routes.activeMap.gmap)
  const rect = document.getElementById('viewport').getBoundingClientRect()
  useLayoutEffect(() => {
    ref.current.style.top = `${pxCoords.y + rect.top}px`
    ref.current.style.left = `${pxCoords.x + rect.left}px`
  }, [])

  const [showPosition, setShowPosition] = useState()

  const handleItemClick = (e, item) => {
    if (item === 'showPosition') {
      e.stopPropagation()
      setShowPosition(true)
    } else {
      actions[item](event, targetType, targetRef)
    }
  }

  const latLng = `${event.latLng.lat().toFixed(6)}, ${event.latLng.lng().toFixed(6)}`

  // IE Edge will trigger a context menu event from the right click that spawned this component
  // We want to close our context menu if the user right clicks again, but need to prevent it from closing before it opens
  const closeIfMountedRef = useRef(() => {})
  useEffect(() => {
    closeIfMountedRef.current = onRequestClose
  }, [])
  const handleRightClick = e => {
    // we don't want system context menus showing up
    e.preventDefault()
    closeIfMountedRef.current()
  }

  return (
    <div onClick={onRequestClose} onContextMenu={handleRightClick} className={styles.scrim}>
      <div ref={ref} className={styles.ContextMenu}>
        {!showPosition && targetItems[targetType].map(item => (
          <div key={item} className={styles.item} onClick={e => handleItemClick(e, item)}>
            <div>{fm(messages[item])}</div>
            <div className={styles.hint}>{hotkeyHints[item]}</div>
          </div>
        ))}
        {showPosition && <div onClick={e => e.stopPropagation()}>
          {latLng} <a href='javascript:;' style={{ marginLeft: '5px', color: '#a0a0a0' }} onClick={() => copyToClipboard(latLng)}>(copy)</a>
        </div>}
      </div>
    </div>
  )
}
